bq.shipmentTracking = (function () {
    var _overlay    = null;
    var _modal      = null;
    var _closeBtn   = null;
    var _titleId    = null;
    var _courierEl  = null;
    var _etaEl      = null;
    var _etaDatesEl = null;
    var _loading    = null;
    var _errorEl    = null;
    var _eventsList = null;
    var _dataUrl    = null;
    var _navEl      = null;
    var _navPrev    = null;
    var _navNext    = null;
    var _navIndicator = null;
    var _allResults = [];
    var _currentIdx = 0;

    function _init() {
        _overlay    = document.getElementById('bq-tracking-modal-overlay');
        _modal      = document.getElementById('bq-tracking-modal');

        if (!_overlay || !_modal) { return; }

        _closeBtn   = document.getElementById('bq-tracking-modal-close');
        _titleId    = document.getElementById('bq-tracking-modal-id');
        _courierEl  = document.getElementById('bq-tracking-modal-courier');
        _etaEl      = document.getElementById('bq-tracking-modal-eta');
        _etaDatesEl = document.getElementById('bq-tracking-modal-eta-dates');
        _loading    = document.getElementById('bq-tracking-loading');
        _errorEl    = document.getElementById('bq-tracking-error');
        _eventsList = document.getElementById('bq-tracking-events');
        _dataUrl    = _overlay.getAttribute('data-tracking-url');

        _navEl        = document.createElement('div');
        _navEl.className = 'modal-nav';
        _navPrev      = document.createElement('button');
        _navPrev.type = 'button';
        _navPrev.className = 'modal-nav-btn';
        _navPrev.innerHTML = '&#8249;';
        _navNext      = document.createElement('button');
        _navNext.type = 'button';
        _navNext.className = 'modal-nav-btn';
        _navNext.innerHTML = '&#8250;';
        _navIndicator = document.createElement('span');
        _navIndicator.className = 'modal-nav-indicator';
        _navEl.appendChild(_navPrev);
        _navEl.appendChild(_navIndicator);
        _navEl.appendChild(_navNext);
        _navEl.style.display = 'none';
        _etaEl.parentNode.insertBefore(_navEl, _etaEl.nextSibling);

        _navPrev.addEventListener('click', function () { _navigate(-1); });
        _navNext.addEventListener('click', function () { _navigate(1); });

        _closeBtn.addEventListener('click', _closeModal);
        _overlay.addEventListener('click', _closeModal);

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { _closeModal(); }
        });

        document.addEventListener('click', function (e) {
            var link = e.target.closest
                ? e.target.closest('.bq-live-shipment-tracking__link')
                : (e.target.classList.contains('bq-live-shipment-tracking__link') ? e.target : null);

            if (!link) { return; }
            e.preventDefault();
            _openModal(link.getAttribute('data-tracking-id'), link.getAttribute('data-carrier'));
        });
    }

    function _renderResult(data) {
        _courierEl.textContent    = data.courier || '';
        _etaEl.style.display      = 'none';
        _etaDatesEl.textContent   = '';
        _eventsList.innerHTML     = '';
        _errorEl.style.display    = 'none';
        _eventsList.style.display = 'none';

        var eta = data.estimated_delivery_time;
        if (eta && (eta.from || eta.to)) {
            var fmt = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' };
            if (eta.window && eta.from && eta.to) {
                _etaDatesEl.textContent = new Date(eta.from).toLocaleString(undefined, fmt)
                    + ' \u2013 ' + new Date(eta.to).toLocaleString(undefined, fmt);
            } else {
                _etaDatesEl.textContent = new Date(eta.from || eta.to).toLocaleString(undefined, fmt);
            }
            _etaEl.style.display = 'block';
        }

        var events = data.events || [];
        if (events.length === 0) {
            _errorEl.textContent   = 'No tracking events found.';
            _errorEl.style.display = 'block';
            return;
        }

        events.sort(function (a, b) { return new Date(a.timestamp) - new Date(b.timestamp); });

        events.forEach(function (ev) {
            var li = document.createElement('li');
            li.className = 'event-item';

            var ts = document.createElement('div');
            ts.className   = 'event-timestamp';
            ts.textContent = new Date(ev.timestamp).toLocaleString(undefined, {
                year: 'numeric', month: 'short', day: 'numeric',
                hour: 'numeric', minute: '2-digit'
            });

            var evt = document.createElement('div');
            evt.className   = 'event-name';
            evt.textContent = ev.ship_event || '';

            li.appendChild(ts);
            li.appendChild(evt);

            if (ev.location) {
                var parts = [];
                if (ev.location.locality)     { parts.push(ev.location.locality); }
                if (ev.location.postal_code)  { parts.push(ev.location.postal_code); }
                if (ev.location.country_code) { parts.push(ev.location.country_code); }
                if (parts.length) {
                    var loc = document.createElement('div');
                    loc.className   = 'event-location';
                    loc.textContent = parts.join(', ');
                    li.appendChild(loc);
                }
            }

            if (ev.event_details) {
                var detail = document.createElement('div');
                detail.className   = 'event-details';
                detail.textContent = ev.event_details;
                li.appendChild(detail);
            }

            _eventsList.appendChild(li);
        });

        _eventsList.style.display = 'block';
    }

    function _navigate(dir) {
        var next = _currentIdx + dir;
        if (next < 0 || next >= _allResults.length) { return; }
        _currentIdx = next;
        _titleId.textContent = _allResults[_currentIdx].tracking_id || '';
        _navIndicator.textContent = (_currentIdx + 1) + ' of ' + _allResults.length;
        _navPrev.disabled = _currentIdx === 0;
        _navNext.disabled = _currentIdx === _allResults.length - 1;
        _renderResult(_allResults[_currentIdx]);
    }

    function _renderTrackingData(resp) {
        _loading.style.display = 'none';

        if (!resp || !resp.success) {
            _errorEl.textContent   = (resp && resp.error) ? resp.error : 'Unable to load tracking data.';
            _errorEl.style.display = 'block';
            return;
        }

        var primary = resp.data;
        _allResults  = [primary].concat(primary.additional_tracking_results || []);
        _currentIdx  = 0;

        _titleId.textContent = primary.tracking_id || '';

        if (_allResults.length > 1) {
            _navIndicator.textContent = '1 of ' + _allResults.length;
            _navPrev.disabled = true;
            _navNext.disabled = false;
            _navEl.style.display = 'flex';
        } else {
            _navEl.style.display = 'none';
        }

        _renderResult(primary);
    }

    function _openModal(trackingId, carrier) {
        _allResults  = [];
        _currentIdx  = 0;
        _titleId.textContent      = trackingId;
        _courierEl.textContent    = '';
        _etaEl.style.display      = 'none';
        _etaDatesEl.textContent   = '';
        _loading.style.display    = 'block';
        _errorEl.style.display    = 'none';
        _eventsList.style.display = 'none';
        _eventsList.innerHTML     = '';
        _navEl.style.display      = 'none';

        _overlay.style.display = 'block';
        _modal.style.display   = 'flex';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', _dataUrl, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) { return; }
            var resp;
            try { resp = JSON.parse(xhr.responseText); } catch (e) { resp = null; }
            _renderTrackingData(resp);
        };
        xhr.send(JSON.stringify({ tracking_id: trackingId, carrier: carrier }));
    }

    function _closeModal() {
        _overlay.style.display = 'none';
        _modal.style.display   = 'none';
    }

    return { init: _init };
}());

bq.init.push(bq.shipmentTracking.init);
